import { render, staticRenderFns } from "./TeachTalksTopics.vue?vue&type=template&id=2b0cc860&"
import script from "./TeachTalksTopics.vue?vue&type=script&lang=js&"
export * from "./TeachTalksTopics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports